/**
 * Business units are gone; the invoice's own company column replaces them. Drop
 * the stale column key so a returning user isn't left with a toggle for a
 * column that no longer exists.
 */
const v41 = (state: any) => {
  const { 'Business Unit': _removed, ...kept } =
    state.options?.tableViews?.invoicesTable ?? {};

  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options?.tableViews,
        invoicesTable: kept,
      },
    },
  };
};

export default v41;
